import React from 'react';

import styles from './Icon.module.scss';

interface IconProps {
  src: string;
  alt: string;
  onClick: React.MouseEventHandler;

  dark?: boolean;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

const Icon = ({
  src,
  alt,
  dark,
  onClick,
  style,
  containerStyle,
}: IconProps) => {
  const imgClassNames = [styles.icon_container__icon];
  if (dark) imgClassNames.push(styles.icon_container__icon__dark);

  return (
    <button
      className={styles.icon_container}
      style={containerStyle}
      onClick={onClick}
      type="button"
    >
      <img
        className={imgClassNames.join(' ')}
        style={style}
        src={src}
        alt={alt}
      />
    </button>
  );
};

Icon.defaultProps = {
  dark: false,
  style: {},
  containerStyle: {},
};

export default Icon;
